export const ONE_MINUTE_WAIT = 60000;
export const DEFAULT_DEBOUNCED_WAIT = 700;
